import React from "react";
import "./ServicesHighlight.css";
import { FaRocket, FaWallet, FaMobileAlt } from "react-icons/fa";

const highlights = [
  {
    icon: FaRocket,
    title: "Livraison rapide",
    desc: "Un site vitrine en 7 jours. Une application mobile en 4 semaines. On respecte les delais parce qu'on sait que votre activite ne peut pas attendre.",
  },
  {
    icon: FaWallet,
    title: "Prix clairs en FCFA",
    desc: "Pas de surprise sur la facture. Le devis est discute et valide avant qu'on commence. Paiement possible en plusieurs tranches.",
  },
  {
    icon: FaMobileAlt,
    title: "Mobile Money natif",
    desc: "Orange Money et Wave integres directement dans vos solutions. Vos clients paient en quelques secondes, sans carte bancaire.",
  },
];

export default function ServicesHighlight() {
  return (
    <section className="services-highlight">
      <h2 data-reveal="">Pourquoi choisir NEXUS SOLUTIONS ?</h2>
      <div className="highlight-list">
        {highlights.map((item, i) => {
          const Icon = item.icon;
          return (
            <div
              className="highlight-card"
              key={item.title}
              data-reveal=""
              data-delay={i * 130}
            >
              <div className="highlight-icon-wrap">
                <Icon size={26} />
              </div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
